import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { WebAuthnService } from '../../../../core/security/multi-factor-auth/web-authn.service';
import { SystemMessageService } from '../../../../core/system-message/system-message-service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { validateForm } from '../../../../shared/form-elements/form-validateForm.function';

@Component({
    selector: 'pcg-register-auth-device-modal',
    templateUrl: './register-auth-device-modal.component.html',
    styleUrls: ['./register-auth-device-modal.component.scss'],
    standalone: false
})
export class RegisterAuthDeviceModalComponent implements OnInit {

	id: number;
	password = '';
	userVerification = true;
	displayName = '';
	displayNameVal = '';

	constructor(public activeModal: NgbActiveModal, private webAuthn: WebAuthnService, private ms: SystemMessageService) { }

	ngOnInit() { }

	validateForm() {
		return this.password !== '' && this.displayNameVal !== '';
	}

	registerCredential() {
		if (this.validateForm()) {
			this.displayName = this.displayNameVal;

			// Make sure their browser is FIDO compatible
			if (!this.webAuthn.isFidoCompatible()) {
				this.activeModal.dismiss();
			}

			// Get the options from the server to use to make a new credential
			this.webAuthn.makeCredentials(this.id, this.password, this.userVerification).subscribe(async publicKeyCredentialCreationOptions => {
				if (publicKeyCredentialCreationOptions.status === 'error') {
					this.ms.setSystemMessage(publicKeyCredentialCreationOptions.errorMessage, 'error');
					this.activeModal.dismiss();
					return;
				}
				try {
					const credential = await navigator['credentials'].create({
						publicKey: publicKeyCredentialCreationOptions
					});
					// Send the credentials to the server to be saved in the database
					this.webAuthn.saveCredentials(credential, this.displayName, this.id, this.password).subscribe((o: any) => {
						if (o.status === 'ok') {
							this.ms.setSystemMessage('The Security Device has been added successfully. You will need to logout and login with your new device to use multi-factor authentication.');
						}
						else {
							this.ms.setSystemMessage('The Security Device could not be added.', 'error');
						}
						this.activeModal.dismiss();
					});
				}
				catch (e) {
					this.ms.setSystemMessage('The Security Device could not be added.', 'error');
					this.activeModal.dismiss();
				}
			});
		}
	}
}
